module.exports = __webpack_public_path__ + "img/Patent_8.177c7975.png";